import type { ReactElement } from "react";

type BrandLogo = () => ReactElement;

export const BrandLogos: Record<string, BrandLogo> = {
  PaymentCard: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 200, height: "auto" }}
      aria-label="Payment card"
    >
      <rect x="6" y="22" width="50" height="36" rx="4" fill="#0a2540" />
      <rect x="6" y="30" width="50" height="6" fill="#fff" />
      <rect x="12" y="44" width="14" height="3" fill="#fff" opacity="0.85" />
      <text
        x="68"
        y="38"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="15"
        fill="#0a2540"
        letterSpacing="0.04em"
      >
        PAYMENT
      </text>
      <text
        x="68"
        y="56"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="15"
        fill="#0a2540"
        letterSpacing="0.04em"
      >
        CARD
      </text>
    </svg>
  ),
  GPay: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 180, height: "auto" }}
      aria-label="Google Pay"
    >
      <g transform="translate(28, 16)">
        <path
          d="M48 24c0-1.8-.2-3.5-.5-5H24v9.5h13.5c-.6 3-2.3 5.5-5 7.2v6h8c4.7-4.3 7.5-10.7 7.5-17.7z"
          fill="#4285F4"
        />
        <path
          d="M24 48c6.8 0 12.5-2.2 16.5-6l-8-6c-2.2 1.5-5 2.4-8.5 2.4-6.5 0-12-4.4-14-10.3H1.7v6.5C5.6 42.7 14.1 48 24 48z"
          fill="#34A853"
        />
        <path
          d="M10 28.1c-.5-1.5-.8-3.1-.8-4.8s.3-3.3.8-4.8v-6.5H1.7C-.1 15.4-.8 19.1-.8 23.3s.7 7.9 2.5 11.3l8.3-6.5z"
          fill="#FBBC04"
        />
        <path
          d="M24 9c3.7 0 7 1.3 9.5 3.7l7.1-7.1C36.5 1.7 30.8-.5 24-.5 14.1-.5 5.6 4.8 1.7 12.5l8.3 6.5C12 13.4 17.5 9 24 9z"
          fill="#EA4335"
        />
        <text
          x="62"
          y="40"
          fontFamily="-apple-system, system-ui, sans-serif"
          fontWeight="500"
          fontSize="34"
          fill="#0a2540"
        >
          Pay
        </text>
      </g>
    </svg>
  ),
  ApplePay: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 170, height: "auto" }}
      aria-label="Apple Pay"
    >
      <g transform="translate(38, 18)" fill="#0a2540">
        <path d="M22.4 12.4c-1.4 1.7-3.7 3-6 2.8-.3-2.3.8-4.7 2.1-6.2 1.4-1.7 3.9-2.9 6-3 .3 2.4-.7 4.7-2.1 6.4zm2 3.2c-3.3-.2-6.2 1.9-7.8 1.9-1.6 0-4-1.8-6.7-1.8-3.4 0-6.6 2-8.4 5.1-3.6 6.2-1 15.4 2.5 20.4 1.7 2.5 3.8 5.3 6.5 5.2 2.6-.1 3.6-1.7 6.7-1.7s4.1 1.7 6.8 1.7c2.8-.1 4.6-2.5 6.3-5 2-2.9 2.8-5.7 2.8-5.9-.1-.1-5.4-2.1-5.5-8.2 0-5.1 4.2-7.5 4.4-7.7-2.4-3.5-6.2-3.9-7.6-4z" />
        <text
          x="42"
          y="36"
          fontFamily="-apple-system, system-ui, sans-serif"
          fontWeight="500"
          fontSize="36"
          letterSpacing="-0.02em"
        >
          Pay
        </text>
      </g>
    </svg>
  ),
  Masterpass: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 200, height: "auto" }}
      aria-label="Mastercard"
    >
      <circle cx="92" cy="28" r="24" fill="#EB001B" />
      <circle cx="128" cy="28" r="24" fill="#F79E1B" />
      <path d="M 110 12 A 24 24 0 0 1 110 44 A 24 24 0 0 1 110 12 Z" fill="#FF5F00" />
      <text
        x="110"
        y="70"
        textAnchor="middle"
        fontFamily="Inter, sans-serif"
        fontWeight="500"
        fontSize="14"
        fill="#0a2540"
        letterSpacing="-0.005em"
      >
        mastercard
      </text>
    </svg>
  ),
  VisaCheckout: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 180, height: "auto" }}
      aria-label="Visa Checkout"
    >
      <text
        x="110"
        y="38"
        textAnchor="middle"
        fontFamily="Inter, sans-serif"
        fontWeight="900"
        fontSize="32"
        fill="#1A1F71"
        fontStyle="italic"
        letterSpacing="-0.02em"
      >
        VISA
      </text>
      <text
        x="110"
        y="62"
        textAnchor="middle"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="22"
        fill="#1A1F71"
        fontStyle="italic"
        letterSpacing="-0.01em"
      >
        Checkout
      </text>
    </svg>
  ),
  QRPayment: () => (
    <svg
      viewBox="0 0 220 80"
     
      style={{ width: "100%", maxWidth: 200, height: "auto" }}
      aria-label="QR code payment"
    >
      <g transform="translate(14, 14)" fill="#0a2540">
        <rect width="52" height="52" fill="none" />
        <path d="M0 0h16v16H0V0zm3 3v10h10V3H3zm3 3h4v4H6V6z" />
        <path d="M36 0h16v16H36V0zm3 3v10h10V3H39zm3 3h4v4h-4V6z" />
        <path d="M0 36h16v16H0V36zm3 3v10h10V39H3zm3 3h4v4H6v-4z" />
        <rect x="20" y="0" width="3" height="3" />
        <rect x="26" y="0" width="3" height="3" />
        <rect x="20" y="6" width="3" height="3" />
        <rect x="30" y="6" width="3" height="3" />
        <rect x="20" y="12" width="3" height="3" />
        <rect x="0" y="20" width="3" height="3" />
        <rect x="6" y="20" width="3" height="3" />
        <rect x="12" y="20" width="3" height="3" />
        <rect x="20" y="20" width="3" height="3" />
        <rect x="26" y="20" width="3" height="3" />
        <rect x="36" y="20" width="3" height="3" />
        <rect x="44" y="20" width="3" height="3" />
        <rect x="0" y="26" width="3" height="3" />
        <rect x="20" y="26" width="3" height="3" />
        <rect x="32" y="26" width="3" height="3" />
        <rect x="44" y="26" width="3" height="3" />
        <rect x="49" y="26" width="3" height="3" />
        <rect x="20" y="32" width="3" height="3" />
        <rect x="26" y="32" width="3" height="3" />
        <rect x="36" y="32" width="3" height="3" />
        <rect x="20" y="38" width="3" height="3" />
        <rect x="32" y="38" width="3" height="3" />
        <rect x="44" y="38" width="3" height="3" />
        <rect x="20" y="44" width="3" height="3" />
        <rect x="26" y="44" width="3" height="3" />
        <rect x="38" y="44" width="3" height="3" />
        <rect x="44" y="44" width="3" height="3" />
        <rect x="49" y="44" width="3" height="3" />
        <rect x="20" y="49" width="3" height="3" />
        <rect x="32" y="49" width="3" height="3" />
        <rect x="40" y="49" width="3" height="3" />
      </g>
      <text
        x="86"
        y="36"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="14"
        fill="#0a2540"
      >
        QR code
      </text>
      <text
        x="86"
        y="54"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="14"
        fill="#0a2540"
      >
        payment
      </text>
    </svg>
  ),
};
